import { DefaultLayout } from 'layouts/DefaultLayout';

import { Hero } from './sections/Hero';

export function HomePage(): React.ReactElement {
  return (
    <DefaultLayout isNested footerHasMargin>
      <Hero />
    </DefaultLayout>
  );
}
